var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_450",
    x: 0,
    y: 0,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    transform: "translate(-21.765 -7.765)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 21.76, 7.76)",
    filter: "url(#Ellipse_450)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_450-2",
    "data-name": "Ellipse 450",
    transform: "translate(6 6)",
    fill: "rgba(130,127,127,0.12)",
    stroke: "#36abef",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    transform: "translate(36.765 22.765)",
    fill: "rgba(49,48,48,0.64)",
    stroke: "#fff6f6",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(65.291 45.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M205.4,163.585l-24.158-13.959a2.591,2.591,0,0,0-3.885,2.242v27.918a2.591,2.591,0,0,0,3.885,2.242L205.4,168.068A2.591,2.591,0,0,0,205.4,163.585ZM182.537,175.3V156.354l16.394,9.473Z",
    transform: "translate(-177.359 -149.275)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybutton);
export default __webpack_public_path__ + "static/media/playbutton.96a30274d919dedd51ccb7b9dbb22a4d.svg";
export { ForwardRef as ReactComponent };